export default "/static/webpack/media/undraw_dashboard.434ec9b5.svg";